export const menulist = [
  {
    keyIndex: 1,
    link: "/dashboard",
    routerName: "dashboard",
    name: "Dashboard",
    icon: "grid",
    requiredRole: [
      "pbx_admin_staff",
      "property_user",
      "super_admin",
      "pbx_reseller",
    ],
  },
  {
    keyIndex: 70,
    link: "/cc-dashboard",
    routerName: "CC-Dashboard",
    name: "CC-Dashboard",
    icon: "phone-call",
    requiredRole: [
      "pbx_admin_staff",
      "property_user",
      "super_admin",
      "pbx_reseller",
    ],
  },
  {
    keyIndex: 2,
    link: "/devices",
    routerName: "devices",
    name: "Devices",
    icon: "smartphone",
    requiredRole: [
      "pbx_admin_staff",
      "property_user",
      "super_admin",
      "pbx_reseller",
    ],
  },
  {
    keyIndex: 3,
    link: "/extensions?page_number=1&page_size=100",
    routerName: "extensions",
    name: "Extensions",
    icon: "cpu",
    requiredRole: [
      "pbx_admin_staff",
      "property_user",
      "super_admin",
      "pbx_reseller",
    ],
  },
  {
    keyIndex: 4,
    link: "/registrations",
    routerName: "registrations",
    name: "Registrations",
    icon: "user-plus",
    requiredRole: [
      "pbx_admin_staff",
      "property_user",
      "super_admin",
      "pbx_reseller",
    ],
  },
  {
    keyIndex: 5,
    link: "/voice-mail?page_number=1&page_size=100",
    routerName: "voice_mail",
    name: "Voice Mail",
    icon: "mail",
    requiredRole: [
      "pbx_admin_staff",
      "property_user",
      "super_admin",
      "pbx_reseller",
    ],
  },
  {
    keyIndex: 6,
    link: "/phone-numbers",
    routerName: "phone_numbers",
    name: "Phone Number",
    icon: "phone-call",
    requiredRole: [
      "pbx_admin_staff",
      "property_user",
      "super_admin",
      "pbx_reseller",
    ],
  },
  {
    keyIndex: 53,
    submenuKey: "sub1",
    subMenuTitle: "App",
    subMenIcon: "sliders",
    requiredRole: [
      "pbx_admin_staff",
      "property_user",
      "super_admin",
      "pbx_reseller",
    ],
    subMenuList: [
      {
        keyIndex: 7,
        link: "/ring-group",
        routerName: "ring_group",
        name: "Ring Group",
        icon: "target",
      },
      {
        keyIndex: 8,
        link: "/voice-menu",
        routerName: "Voice Menu",
        name: "Voice Menu",
        icon: "voicemail",
      },
      {
        keyIndex: 9,
        link: "/call-flow",
        routerName: "call Flow",
        name: "Call Flow",
        icon: "trending-up",
      },
      {
        keyIndex: 48,
        link: "/time-condition?page_number=1&page_size=100",
        routerName: "time-condition",
        name: "Time Condition",
        icon: "sunset",
      },
      {
        keyIndex: 10,
        link: "/media/ivr",
        routerName: "media",
        name: "Media",
        icon: "play",
      },
    ],
  },
  {
    keyIndex: 11,
    link: "/call-records?page_number=1&page_size=1000",
    routerName: "Call Records",
    name: "Call Records",
    icon: "file-text",
    requiredRole: [
      "pbx_admin_staff",
      "property_user",
      "super_admin",
      "pbx_reseller",
    ],
  },
  // {
  //   keyIndex: 54,
  //   submenuKey: "sub2",
  //   subMenuTitle: "Campaign",
  //   subMenIcon: "rss",
  //   requiredRole: [
  //     "pbx_admin_staff",
  //     "property_user",
  //     "super_admin",
  //     "pbx_reseller",
  //   ],
  //   subMenuList: [
  //     {
  //       keyIndex: 12,
  //       link: "/campaign/template",
  //       routerName: "Template",
  //       name: "Campaign Template List",
  //       icon: "play-circle",
  //     },
  //     {
  //       keyIndex: 13,
  //       link: "/campaign",
  //       routerName: "broadcast-dashboard",
  //       name: "Campaign",
  //       icon: "grid",
  //     },
  //     {
  //       keyIndex: 14,
  //       link: "/campaign/logs",
  //       routerName: "logs",
  //       name: "Logs",
  //       icon: "file-text",
  //     },
  //     {
  //       keyIndex: 15,
  //       link: "/message-list",
  //       routerName: "message-list",
  //       name: "List",
  //       icon: "list",
  //     },
  //   ],
  // },
  {
    keyIndex: 16,
    link: "/fax/inbound",
    routerName: "fax",
    name: "Fax",
    icon: "printer",
    requiredRole: [
      "pbx_admin_staff",
      "property_user",
      "super_admin",
      "pbx_reseller",
    ],
  },
  {
    keyIndex: 17,
    link: "/wakeup-call",
    routerName: "Wakeup Call",
    name: "Wakeup Call",
    icon: "bell",
    requiredRole: [
      "pbx_admin_staff",
      "property_user",
      "super_admin",
      "pbx_reseller",
    ],
  },
  {
    keyIndex: 55,
    submenuKey: "sub3",
    subMenuTitle: "My Account",
    subMenIcon: "info",
    requiredRole: [
      "pbx_admin_staff",
      "property_user",
      "super_admin",
      "pbx_reseller",
    ],
    subMenuList: [
      {
        keyIndex: 18,
        link: "/account/subscription",
        routerName: "subscription",
        name: "Subscription",
        icon: "info",
      },
      {
        keyIndex: 19,
        link: "/account/invoices",
        routerName: "invoices",
        name: "Invoices",
        icon: "file-minus",
      },
      {
        keyIndex: 20,
        link: "/account/ticket",
        routerName: "ticket",
        name: "Ticket",
        icon: "tag",
      },
    ],
  },
  {
    keyIndex: 56,
    submenuKey: "sub4",
    subMenuTitle: "Hotel App",
    subMenIcon: "home",
    requiredRole: [
      "pbx_admin_staff",
      "property_user",
      "super_admin",
      "pbx_reseller",
    ],
    subMenuList: [
      {
        keyIndex: 24,
        link: "/hotel-app/room-status?page_number=1&page_size=100",
        routerName: "Room Status",
        name: "Room Status",
        icon: "alert-circle",
      },
      {
        keyIndex: 25,
        link: "/hotel-app/call-rate",
        routerName: "call rate",
        name: "Call Rates",
        icon: "dollar-sign",
      },
      {
        keyIndex: 51,
        link: "/hotel-app/staff?page_number=1&page_size=100",
        routerName: "staff",
        name: "Staff",
        icon: "users",
      },
    ],
  },
  {
    keyIndex: 41,
    link: "/super-dashboard?data_type=device_statistics",
    routerName: "dashboard",
    name: "Super Dashboard",
    icon: "grid",
    requiredRole: ["pbx_admin_staff", "super_admin", "pbx_reseller"],
    isSuperAdmin: true,
    isResellerAdmin: true,
  },
  {
    keyIndex: 26,
    link: "/domain?page_number=1&page_size=100",
    routerName: "domain",
    name: "Domain",
    icon: "globe",
    requiredRole: ["pbx_admin_staff", "super_admin", "pbx_reseller"],
    isSuperAdmin: true,
    isResellerAdmin: true,
  },
  {
    keyIndex: 68,
    link: "/device-data?page_number=1&page_size=100",
    routerName: "Device Data",
    name: "Device Data",
    icon: "cpu",
    requiredRole: ["pbx_admin_staff", "super_admin", "pbx_reseller"],
    isSuperAdmin: true,
    isResellerAdmin: true,
  },
  {
    keyIndex: 57,
    submenuKey: "sub6",
    subMenuTitle: "Users",
    subMenIcon: "users",
    requiredRole: ["pbx_admin_staff", "super_admin"],
    isSuperAdmin: true,
    subMenuList: [
      {
        keyIndex: 45,
        link: "/user-permission",
        routerName: "User Permission",
        name: "User Permission",
        icon: "user-plus",
      },
      {
        keyIndex: 28,
        link: "/staff-user?page_number=1&page_size=100",
        routerName: "Staff Users",
        name: "Staff Users",
        icon: "user",
      },
      {
        keyIndex: 29,
        link: "/reseller-user?page_number=1&page_size=100",
        routerName: "Reseller User",
        name: "Reseller User",
        icon: "user-check",
      },
      {
        keyIndex: 30,
        link: "/property-user?page_number=1&page_size=100",
        routerName: "Property Users",
        name: "Property Users",
        icon: "users",
      },
    ],
  },
  {
    keyIndex: 58,
    submenuKey: "sub8",
    subMenuTitle: "Phone Number",
    subMenIcon: "phone",
    requiredRole: ["super_admin", "pbx_admin_staff"],
    isSuperAdmin: true,
    subMenuList: [
      {
        keyIndex: 36,
        link: "/phone-number?page_number=1&page_size=100",
        routerName: "Phone Number",
        name: "Phone Numbers",
        icon: "phone",
      },
      {
        keyIndex: 37,
        link: "/destination",
        routerName: "Destination",
        name: "Destinations",
        icon: "phone-call",
      },
      // {
      //   keyIndex: 38,
      //   link: "/porting",
      //   routerName: "Porting",
      //   name: "Porting",
      //   icon: "phone-incoming",
      // },
    ],
  },
  {
    keyIndex: 59,
    submenuKey: "sub7",
    subMenuTitle: "Settings",
    subMenIcon: "settings",
    requiredRole: ["pbx_admin_staff", "super_admin"],
    isSuperAdmin: true,
    subMenuList: [
      // {
      //   keyIndex: 31,
      //   link: "/server",
      //   routerName: "Servers",
      //   name: "Servers",
      //   icon: "server",
      // },
      // {
      //   keyIndex: 32,
      //   link: "/security-group",
      //   routerName: "Security Group",
      //   name: "Security Group",
      //   icon: "shield",
      // },
      {
        keyIndex: 33,
        link: "/device-profile?page_number=1&page_size=100",
        routerName: "Device Profile",
        name: "Device Profile",
        icon: "airplay",
      },
      {
        keyIndex: 34,
        link: "/service-provider",
        routerName: "Service Provider",
        name: "Service Provider",
        icon: "airplay",
      },
      // {
      //   keyIndex: 35,
      //   link: "/server-health",
      //   routerName: "Server Health",
      //   name: "Server Health",
      //   icon: "server",
      // },
    ],
  },
  {
    keyIndex: 60,
    submenuKey: "sub9",
    subMenuTitle: "Server",
    subMenIcon: "server",
    requiredRole: ["pbx_admin_staff", "super_admin"],
    isSuperAdmin: true,
    subMenuList: [
      {
        keyIndex: 31,
        link: "/server?page_number=1&page_size=100",
        routerName: "Servers",
        name: "Servers",
        icon: "server",
      },
      {
        keyIndex: 42,
        link: "/media-server",
        routerName: "Media Server",
        name: "Media Server",
        icon: "file",
      },
      {
        keyIndex: 43,
        link: "/ip-server?page_number=1&page_size=100",
        routerName: "Ip Server",
        name: "Ip Server",
        icon: "server",
      },
      {
        keyIndex: 44,
        link: "/ip-table",
        routerName: "Ip Table",
        name: "Blocked Ip",
        icon: "table",
      },
      {
        keyIndex: 72,
        link: "/whitelist-ip-table",
        routerName: "IP Whitelist",
        name: "IP Whitelist",
        icon: "clipboard",
      },
      // {
      //   keyIndex: 32,
      //   link: "/security-group?page_number=1&page_size=100",
      //   routerName: "Security Group",
      //   name: "Security Group",
      //   icon: "shield",
      // },
      {
        keyIndex: 35,
        link: "/server-health",
        routerName: "Server Health",
        name: "Server Health",
        icon: "server",
      },
    ],
  },

  {
    keyIndex: 66,
    submenuKey: "sub11",
    subMenuTitle: "Network",
    subMenIcon: "rss",
    requiredRole: ["pbx_admin_staff", "super_admin"],
    isSuperAdmin: true,
    subMenuList: [
      {
        keyIndex: 67,
        link: "/ppp-user?page_number=1&page_size=100",
        routerName: "PPP User",
        name: "PPP User",
        icon: "users",
      },
      {
        keyIndex: 71,
        link: "/mikrotik-devices?page_number=1&page_size=100",
        routerName: "Mikrotik Devices",
        name: "Mikrotik Devices",
        icon: "file",
      },
    ],
  },
  // {
  //   keyIndex: 47,
  //   link: "/extension-user",
  //   routerName: "extension-user",
  //   name: "Extension User",
  //   icon: "printer",
  //   requiredRole: [
  //     "pbx_admin_staff",
  //     "property_user",
  //     "super_admin",
  //     "pbx_reseller",
  //   ],
  //   isSuperAdmin: true,
  //   isResellerAdmin: true,
  // },
  // {
  //   keyIndex: 49,
  //   link: "/id-scan-app",
  //   routerName: "id-scan-app",
  //   name: "ID Scan App",
  //   icon: "square",
  //   requiredRole: ["pbx_admin_staff", "super_admin", "pbx_reseller"],
  //   isSuperAdmin: true,
  //   isResellerAdmin: true,
  // },
  // {
  //   keyIndex: 50,
  //   link: "/mobile-app-provision?page_number=1&page_size=100",
  //   routerName: "mobile-app-provision",
  //   name: "Mobile App Provision",
  //   icon: "smartphone",
  //   requiredRole: ["pbx_admin_staff", "super_admin", "pbx_reseller"],
  //   isSuperAdmin: true,
  //   isResellerAdmin: true,
  // },
  {
    keyIndex: 46,
    link: "/map",
    routerName: "map",
    name: "Map",
    icon: "map",
    requiredRole: [
      "pbx_admin_staff",
      "property_user",
      "super_admin",
      "pbx_reseller",
    ],
    isSuperAdmin: true,
    isResellerAdmin: true,
  },
  {
    keyIndex: 61,
    link: "/alerts?page_size=100&is_check=0",
    routerName: "alerts",
    name: "Alerts",
    icon: "bell",
    requiredRole: ["pbx_admin_staff", "super_admin"],
    isSuperAdmin: true,
    isResellerAdmin: true,
  },
  // {
  //   keyIndex: 62,
  //   link: "/contact-book-users?page_size=100",
  //   routerName: "Contact Book List",
  //   name: "Contact Book List",
  //   icon: "list",
  //   requiredRole: [
  //     "pbx_admin_staff",
  //     "property_user",
  //     "super_admin",
  //     "pbx_reseller",
  //   ],
  //   isResellerAdmin: true,
  // },
  {
    keyIndex: 52,
    submenuKey: "sub10",
    subMenuTitle: "Call Center",
    routerName: "call center",
    subMenIcon: "framer",
    requiredRole: [
      "pbx_admin_staff",
      "property_user",
      "super_admin",
      "pbx_reseller",
    ],
    subMenuList: [
      {
        keyIndex: 64,
        link: "/cc-agents?page_number=1&page_size=100",
        routerName: "CC-Agents",
        name: "CC-Agents",
        icon: "users",
      },
      {
        keyIndex: 65,
        link: "/cc-queue?page_number=1&page_size=100",
        routerName: "CC-Queues",
        name: "CC-Queues",
        icon: "link",
      },
      {
        keyIndex: 69,
        link: "/cc-reports/agent",
        routerName: "CC-Reports",
        name: "CC-Reports",
        icon: "file-text",
      },
    ],
  },
  {
    keyIndex: 63,
    link: "/messaging?page_size=100",
    routerName: "Messaging",
    name: "Messaging",
    icon: "message-square",
    requiredRole: [
      "pbx_admin_staff",
      "property_user",
      "super_admin",
      "pbx_reseller",
    ],
    isResellerAdmin: true,
  },
];
// Last Submenu = sub11
// Last Key Index = 72

// {
//   submenuKey: "sub5",
//   subMenuTitle: "Settings",
//   subMenIcon: "settings",
//   requiredRole: ["pbx_admin_staff", "property_user","super_admin","pbx_reseller"],
//   subMenuList: [
//     {
//       keyIndex: 29,
//       link: "/settings/notification",
//       routerName: "notification",
//       name: "Notification",
//       icon: "bell",
//     },
//     {
//       keyIndex: 30,
//       link: "/settings/alerts",
//       routerName: "alerts",
//       name: "Alerts",
//       icon: "alert-triangle",
//     },
//   ],
// },

// {
//   keyIndex: 7,
//   link: "/conversationDetails",
//   routerName: "conversationDetails",
//   name: "Messages",
//   icon: "phone-outgoing",
// },
// {
//   keyIndex: 8,
//   link: "/E911CallRecords",
//   routerName: "E911CallRecords",
//   name: "E911 Calls",
//   icon: "phone-outgoing",
// },
// {
//   keyIndex: 21,
//   link: "/hotel-app/product",
//   routerName: "product",
//   name: "Product",
//   icon: "shopping-bag",
// },
// {
//   keyIndex: 22,
//   link: "/hotel-app/staff",
//   routerName: "staff",
//   name: "Maid List",
//   icon: "users",
// },
// {
//   keyIndex: 23,
//   link: "/hotel-app/minibar",
//   routerName: "minibar",
//   name: "Minibar",
//   icon: "bar-chart",
// },

// {
//   keyIndex: 39,
//   link: "/notification-alert",
//   routerName: "Notification Alert",
//   name: "Notification Alert",
//   icon: "bell",
// },
